function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "img-delete_module_svg__a",
  d: "M0 .74h62.35v79.688H0z"
}), React.createElement("path", {
  id: "img-delete_module_svg__c",
  d: "M.01.843h8.107V2.51H.01z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("circle", {
  fill: "#F2F3F7",
  cx: 80,
  cy: 83,
  r: 61
}), React.createElement("path", {
  d: "M96.517 63.394V37.633l-16.693-13.8h-39.17a4.82 4.82 0 0 0-4.821 4.82v68.383a4.82 4.82 0 0 0 4.82 4.82h51.044a4.82 4.82 0 0 0 4.82-4.82v-9.953",
  fill: "#FFF"
}), React.createElement("path", {
  d: "M79.213 23.975v10.817a3.095 3.095 0 0 0 3.094 3.095h13.599",
  fill: "#E9EAF0"
}), React.createElement("g", {
  transform: "translate(35 22.26)"
}, React.createElement("mask", {
  id: "img-delete_module_svg__b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#img-delete_module_svg__a"
})), React.createElement("path", {
  d: "M34.608 80.4a.81.81 0 0 1-.216.028H5.652a5.611 5.611 0 0 1-3.996-1.656A5.608 5.608 0 0 1 0 74.775V6.393c0-1.51.588-2.93 1.655-3.998A5.616 5.616 0 0 1 5.654.74h39.17c.194 0 .382.068.53.191l16.694 13.8a.83.83 0 0 1 .303.642v38.684a.833.833 0 0 1-1.666 0l-.002-38.292L44.523 2.406H5.654a3.952 3.952 0 0 0-2.818 1.168 3.96 3.96 0 0 0-1.167 2.82l-.001 68.381c0 1.064.415 2.065 1.167 2.82a3.956 3.956 0 0 0 2.82 1.166h28.738a.835.835 0 0 1 .215 1.64",
  fill: "#C0C2CC",
  mask: "url(#img-delete_module_svg__b)"
})), React.createElement("path", {
  d: "M93.487 41.073a.81.81 0 0 1-.216.028h-13.49a3.877 3.877 0 0 1-2.759-1.143 3.877 3.877 0 0 1-1.143-2.76l.001-10.73a.833.833 0 0 1 1.666 0v10.73c0 .598.232 1.159.655 1.582a2.22 2.22 0 0 0 1.58.654h13.49a.833.833 0 0 1 .216 1.639M87.776 62.107a.817.817 0 0 1-.216.028H44.596a.833.833 0 0 1 0-1.667l42.964.001a.833.833 0 0 1 .216 1.638M87.776 69.791a.817.817 0 0 1-.216.029H44.596a.833.833 0 0 1 0-1.667H87.56a.833.833 0 0 1 .216 1.639M87.776 77.476a.81.81 0 0 1-.215.028H44.595a.833.833 0 0 1 0-1.666H87.56a.833.833 0 0 1 .216 1.638M69.608 85.16a.817.817 0 0 1-.217.028H44.682a.832.832 0 1 1 0-1.666h24.71a.832.832 0 0 1 .216 1.638M69.608 92.845a.817.817 0 0 1-.217.028H44.28a.832.832 0 1 1 0-1.666h25.112a.832.832 0 0 1 .217 1.638M45.97 53.105a.834.834 0 0 1-1.05-.805V37.447a3.908 3.908 0 0 1 3.904-3.903H65.49a.832.832 0 1 1 0 1.666H48.824a2.242 2.242 0 0 0-2.237 2.236V52.3c0 .386-.261.71-.616.805",
  fill: "#C0C2CC"
}), React.createElement("path", {
  d: "M102.575 96.058c0 7.859-6.37 14.23-14.229 14.23-7.86 0-14.23-6.371-14.23-14.23 0-7.86 6.37-14.23 14.23-14.23 7.858 0 14.23 6.37 14.23 14.23",
  fill: "#FF4056"
}), React.createElement("g", {
  transform: "translate(104 103.26)"
}, React.createElement("mask", {
  id: "img-delete_module_svg__d",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#img-delete_module_svg__c"
})), React.createElement("path", {
  d: "M7.5 2.482a.817.817 0 0 1-.217.028H.844a.833.833 0 0 1 0-1.666h6.44A.835.835 0 0 1 7.5 2.481",
  fill: "#FF4056",
  mask: "url(#img-delete_module_svg__d)"
})), React.createElement("path", {
  d: "M107.602 116.334a.838.838 0 0 1-.807-.216l-4.553-4.554a.834.834 0 0 1 1.178-1.178l4.554 4.553a.833.833 0 0 1-.372 1.395M97.01 120.232a.833.833 0 0 1-1.05-.805v-6.44a.835.835 0 0 1 1.667 0v6.44c0 .385-.262.71-.617.805",
  fill: "#FF4056"
}), React.createElement("path", {
  d: "M84.596 90.808v-.75a2.25 2.25 0 0 1 2.25-2.25h3a2.25 2.25 0 0 1 2.25 2.25v.75h3a.75.75 0 0 1 0 1.5h-.75v9.75a2.25 2.25 0 0 1-2.25 2.25h-7.5a2.25 2.25 0 0 1-2.25-2.25v-9.75h-.75a.749.749 0 1 1 0-1.5h3zm1.5 0h4.5v-.75a.75.75 0 0 0-.75-.75h-3a.75.75 0 0 0-.75.75v.75zm6.75 1.5h-9v9.75c0 .415.335.75.75.75h7.5a.75.75 0 0 0 .75-.75v-9.75zm-6.75 3a.75.75 0 1 1 1.5 0v4.5a.75.75 0 1 1-1.5 0v-4.5zm3 0a.75.75 0 1 1 1.5 0v4.5a.75.75 0 1 1-1.5 0v-4.5z",
  fill: "#FFF"
}));

var SvgImgDeleteModule = function SvgImgDeleteModule(props) {
  return React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150"
  }, props), _ref, _ref2);
};

export default SvgImgDeleteModule;